var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChartSquare02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.9999V11.9999M10 13.9999V9.99988M6 13.9999V5.99988M4 17.9999C2.89543 17.9999 2 17.1044 2 15.9999V3.99988C2 2.89531 2.89543 1.99988 4 1.99988H16C17.1046 1.99988 18 2.89531 18 3.99988V15.9999C18 17.1044 17.1046 17.9999 16 17.9999H4Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartSquare02);
export default __webpack_public_path__ + "static/media/bar-chart-square-02.74bc3033c0dc70b52151b7b5f4fca296.svg";
export { ForwardRef as ReactComponent };